import Immutable from 'seamless-immutable'
import * as actions from './actions'
import * as offlineData from './startPage.json'

const initialState = Immutable.from({
  entry: null,
  entries: null,
  loading: false,
  error: false,
  data: {
    startPage: offlineData.default,
    contentPage: null,
    menu: null,
  },
  errors: {
    entryError: false,
    menuError: false,
    errorCode: null,
  },
  fetching: false,
  apiType: null,
  isWebView: false,
})

const contentfulPage = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.REQUEST_ENTRY:
      return state.set('loading', true).set('error', false)

    case actions.RECEIVE_ENTRY:
      return state
        .set('entry', payload)
        .set('loading', false)
        .set('error', false)

    case actions.REQUEST_START_PAGE_ENTRY:
    case actions.REQUEST_CONTENT_PAGE_ENTRY:
    case actions.REQUEST_MENU_ENTRY:
      return state.set('fetching', true).setIn(['errors', 'entryError'], false)

    case actions.RECEIVE_START_PAGE_ENTRY:
      return state.setIn(['data', 'startPage'], payload).set('fetching', false)

    case actions.RECEIVE_CONTENT_PAGE_ENTRY:
      return state.setIn(['data', 'contentPage'], payload).set('fetching', false)

    case actions.RECEIVE_MENU_ENTRY:
      return state.setIn(['data', 'menu'], payload).set('fetching', false)

    case actions.ERROR_START_PAGE_ENTRY:
    case actions.ERROR_CONTENT_PAGE_ENTRY:
      return state
        .setIn(['errors', 'entryError'], true)
        .setIn(['errors', 'errorCode'], payload)
        .set('fetching', false)

    case actions.ERROR_MENU_ENTRY:
      return state
        .setIn(['errors', 'menuError'], true)
        .setIn(['errors', 'errorCode'], payload)
        .set('fetching', false)

    case actions.API_TYPE:
      return state.set('apiType', payload)
    case actions.SET_WEB_VIEW_STATUS:
      return state.set('isWebView', payload)
    default:
      return state
  }
}

export default contentfulPage
